import { call, select } from 'redux-saga/effects'
import {getUserIdentity} from "state/app/selectors";
import {openPhone} from "lib/native";

export default function* openPhoneSaga(action) {
  const userIdentity = yield select(getUserIdentity)
  return yield call(openPhone, userIdentity.get("platform"), action.payload.phoneNumber);
}



// WEBPACK FOOTER //
// ./src/state/app/sagas/openPhone.js